import { ajax } from '@egr/wcf/modules/utils/async';
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Texture as BJSTexture } from "@babylonjs/core/Materials/Textures/texture";
import { Util } from './utils/Util';
import { ZipDocumentContainer } from '@egr/wcf/modules/core/io';
import { degToRad } from '@egr/wcf/modules/utils/math';
import { GfjLoader } from './GfjLoader';
import { fromDataUri } from '@egr/wcf/modules/utils/arraybuffer';
export function downloadContent(url, responseType = 'arraybuffer') {
    return ajax('GET', url, null, {
        responseType
    });
}
export class MATZLoader {
    static async getMaterialOfMATZ(pMATZURL, pId, pEntry, pRoomManager, pMatManager) {
        this.mRoomManager = pRoomManager;
        this.mMatManager = pMatManager;
        let tPromise = this.getMaterialDefinition(pMATZURL, pId, pEntry);
        return (tPromise);
    }
    static async createMATofImage(pId, pImage, pRoomManager) {
        let timgHash = Util.getHashOfString(pImage);
        let tId = "importedImage_-_" + timgHash;
        let tTexture = BJSTexture.CreateFromBase64String(pImage, "importedImage" + "_" + timgHash, pRoomManager.app.scene, false, true, BJSTexture.TRILINEAR_SAMPLINGMODE);
        let timgExt = Util.getImgExt(pImage.trim());
        let talpha = timgExt == "png" ? true : false;
        let tFileName = tId + "." + timgExt;
        let tnc = ZipDocumentContainer.NewContainer();
        tnc.addFile(fromDataUri(pImage.trim()), tFileName);
        let tMaterial = new PbrMaterial(tId, pRoomManager.MatManager);
        let tPromise = await pRoomManager.MatManager.createResourceTexture(tId, tFileName, talpha, tnc).then((pTexture) => {
            if (pTexture != null) {
                tMaterial.albedoTexture = pTexture;
            }
        });
        tMaterial.metallic = 0;
        tMaterial.roughness = 1;
        pRoomManager.MatManager.addMaterial(tId, tMaterial);
        this.addCategory_imported(pRoomManager);
        let tTxtData = this._newTextureData(tId, timgHash, pImage);
        pRoomManager.externalMaterialList.push(tTxtData);
        return ("importedImage_-_" + timgHash);
    }
    static separateContent(pMATfile, pSplitStr) {
        let tRes = new Array();
        let ttmp = pMATfile.split(pSplitStr);
        for (let tStr of ttmp)
            if (tStr.trim() !== "")
                tRes.push(tStr.trim());
        return (tRes);
    }
    static addCategory_imported(pRoomManager) {
        let tTxtCategory = {};
        tTxtCategory.id = "importedImage";
        tTxtCategory.smallIcon = "";
        tTxtCategory.translation = new Array();
        let tarrTrans_de = {};
        tarrTrans_de.lang = "de";
        tarrTrans_de.text = "importiert";
        tTxtCategory.translation.push(tarrTrans_de);
        let tarrTrans_en = {};
        tarrTrans_en.lang = "en";
        tarrTrans_en.text = "imported";
        tTxtCategory.translation.push(tarrTrans_en);
        let tTXTcatexists = pRoomManager.isTextureCategoryAlreadyAvailable(tTxtCategory);
        if (!tTXTcatexists)
            pRoomManager._extMaterialCategories.push(tTxtCategory);
    }
    static _newTextureData(pId, pValue, psmallImage) {
        let tTxtData = {};
        tTxtData.id = pValue;
        tTxtData.category = "importedImage";
        tTxtData.materialValue = pId;
        tTxtData.smallIcon = psmallImage;
        tTxtData.albedocolor = "";
        tTxtData.bumpMap = "";
        tTxtData.bump_uScale = 0;
        tTxtData.bump_vScale = 0;
        tTxtData.matzFile = "";
        tTxtData.metallic = 0;
        tTxtData.reflectivity = -1;
        tTxtData.roughness = 1;
        tTxtData.roughnessMap = "";
        tTxtData.specular = "";
        tTxtData.specular_color = "";
        tTxtData.specular_power = -1;
        tTxtData.specular_uScale = 0;
        tTxtData.specular_vScale = 0;
        tTxtData.textureMap = "";
        tTxtData.texture_uScale = -1;
        tTxtData.texture_vScale = -1;
        tTxtData.translation = new Array();
        let tarrTrans_de = {};
        tarrTrans_de.lang = "de";
        tarrTrans_de.text = "importiert";
        tTxtData.translation.push(tarrTrans_de);
        let tarrTrans_en = {};
        tarrTrans_en.lang = "en";
        tarrTrans_en.text = "imported";
        tTxtData.translation.push(tarrTrans_en);
        return (tTxtData);
    }
    static getMatEntry(pKey, pMATcontent) {
        let tRes = "";
        for (let tLine of pMATcontent) {
            if (tLine.indexOf(pKey) == 0) {
                tRes = tLine;
                break;
            }
        }
        return (tRes);
    }
    static getMatType(pMATcontent) {
        let tRes = "";
        let tLine = this.getMatEntry("type", pMATcontent);
        if (tLine == "")
            return (tRes);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (tRes);
        tRes = (ttmpLine[1].trim()).toLocaleLowerCase();
        return (tRes);
    }
    static getShininess(pMATcontent) {
        let tRes = 30;
        let tLine = this.getMatEntry("shi", pMATcontent);
        if (tLine == "")
            return (tRes);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (tRes);
        tRes = parseFloat(ttmpLine[1]);
        return (tRes);
    }
    static getReflectivity(pMATcontent) {
        let tRes = 0;
        let tLine = this.getMatEntry("reflection", pMATcontent);
        if (tLine == "")
            return (tRes);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (tRes);
        tRes = parseFloat(ttmpLine[1]);
        return (tRes);
    }
    static getDiffuseColor(pMATcontent, pMaterial) {
        let tLine = this.getMatEntry("dif", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        pMaterial.albedoColor = Util.MATcolor2BABYLONColor3(ttmpLine[1] + " " + ttmpLine[2] + " " + ttmpLine[3]);
        //pMaterial.albedoColor.toLinearSpaceToRef(pMaterial.albedoColor);
        return (pMaterial);
    }
    static getSpecularColor(pMATcontent, pMaterial) {
        let tSpecularColor = Color3.Black();
        let tLine = this.getMatEntry("spe", pMATcontent);
        if (tLine == "")
            return (tSpecularColor);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (tSpecularColor);
        tSpecularColor = Util.MATcolor2BABYLONColor3(ttmpLine[1] + " " + ttmpLine[2] + " " + ttmpLine[3]);
        return (tSpecularColor);
    }
    static getEmissiveColor(pMATcontent, pMaterial) {
        let tLine = this.getMatEntry("emission", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        pMaterial.emissiveColor = Util.MATcolor2BABYLONColor3(ttmpLine[1] + " " + ttmpLine[2] + " " + ttmpLine[3]);
        return (pMaterial);
    }
    static getEmissiveIntensity(pMATcontent, pMaterial) {
        let tLine = this.getMatEntry("luminance", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (pMaterial);
        pMaterial.emissiveIntensity = parseInt(ttmpLine[1], 10);
        return (pMaterial);
    }
    static getMetalicValue(pMATcontent, pMaterial) {
        let tLine = this.getMatEntry("metallic", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (pMaterial);
        pMaterial.metallic = parseFloat(ttmpLine[1]);
        return (pMaterial);
    }
    static getRoughnessValue(pMATcontent, pMaterial) {
        let tLine = this.getMatEntry("roughness", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (pMaterial);
        pMaterial.roughness = parseFloat(ttmpLine[1]);
        return (pMaterial);
    }
    static getTransparencyValue(pMATcontent, pMaterial, pType) {
        pMaterial.alpha = 1;
        if (pType == "illuminant")
            return (pMaterial);
        let tLine = this.getMatEntry("tra", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 2)
            return (pMaterial);
        pMaterial.alpha = parseFloat(ttmpLine[1]);
        return (pMaterial);
    }
    static async getTexture(pMATcontent, pMaterial, pId, pZIP) {
        let tLine = this.getMatEntry("tex", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        let talpha = ttmpLine[2] == "png" ? true : false;
        let tPromise = await this.mMatManager.createResourceTexture(pId, ttmpLine[3] + "." + ttmpLine[2], talpha, pZIP).then((pTexture) => {
            if (pTexture != null) {
                pMaterial.albedoTexture = pTexture;
                if (pMaterial.albedoTexture !== null) {
                    pMaterial.albedoTexture.uScale = this.mScaleU;
                    pMaterial.albedoTexture.vScale = this.mScaleU;
                }
            }
        });
        return (pMaterial);
    }
    static async getTextureScale(pMATcontent, pMaterial, pId, pZIP) {
        let tLine = this.getMatEntry("scale", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        let tuScale = parseFloat(ttmpLine[1]);
        let tvScale = parseFloat(ttmpLine[2]);
        this.mScaleU = tuScale;
        this.mScaleV = tvScale;
        return (pMaterial);
    }
    static async getBumpTexture(pMATcontent, pMaterial, pId, pZIP) {
        let tLine = this.getMatEntry("bumps", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 3)
            return (pMaterial);
        let talpha = ttmpLine[1] == "png" ? true : false;
        let tPromise = await this.mMatManager.createResourceTexture(pId + "_bump", ttmpLine[2] + "." + ttmpLine[1], talpha, pZIP).then((pTexture) => {
            if (pTexture != null) {
                pMaterial.bumpTexture = pTexture;
                if (pMaterial.bumpTexture !== null) {
                    pMaterial.bumpTexture.uScale = this.mScaleU;
                    pMaterial.bumpTexture.vScale = this.mScaleU;
                }
            }
        });
        return (pMaterial);
    }
    static async getBumpTextureScale(pMATcontent, pMaterial, pId, pZIP) {
        let tLine = this.getMatEntry("nscale", pMATcontent);
        if (pMaterial.albedoTexture != null && pMaterial.bumpTexture != null) {
            pMaterial.bumpTexture.uScale = pMaterial.albedoTexture.uScale;
            pMaterial.bumpTexture.vScale = pMaterial.albedoTexture.vScale;
        }
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        let tuScale = parseFloat(ttmpLine[1]);
        let tvScale = parseFloat(ttmpLine[2]);
        if (pMaterial.bumpTexture !== null) {
            pMaterial.bumpTexture.uScale = tuScale;
            pMaterial.bumpTexture.vScale = tvScale;
        }
        return (pMaterial);
    }
    static async getRotateValue(pMATcontent, pMaterial, pId, pZIP) {
        let tLine = this.getMatEntry("rotate", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        let tuRotate = parseFloat(ttmpLine[1]);
        let tvRotate = parseFloat(ttmpLine[2]);
        let twRotate = parseFloat(ttmpLine[3]);
        if (pMaterial.albedoTexture != null) {
            pMaterial.albedoTexture.uAng = degToRad(tuRotate);
            pMaterial.albedoTexture.vAng = degToRad(tvRotate);
            pMaterial.albedoTexture.wAng = degToRad(twRotate);
        }
        if (pMaterial.bumpTexture != null) {
            pMaterial.bumpTexture.uAng = degToRad(tuRotate);
            pMaterial.bumpTexture.vAng = degToRad(tvRotate);
            pMaterial.bumpTexture.wAng = degToRad(twRotate);
        }
        if (pMaterial.microSurfaceTexture != null) {
            pMaterial.microSurfaceTexture.uAng = degToRad(tuRotate);
            pMaterial.microSurfaceTexture.vAng = degToRad(tvRotate);
            pMaterial.microSurfaceTexture.wAng = degToRad(twRotate);
        }
        return (pMaterial);
    }
    static async getRoughnessTexture(pMATcontent, pMaterial, pId, pZIP) {
        let tLine = this.getMatEntry("roughness image", pMATcontent);
        if (tLine == "")
            return (pMaterial);
        let ttmpLine = this.separateContent(tLine, " ");
        if (ttmpLine.length != 4)
            return (pMaterial);
        let talpha = ttmpLine[1] == "png" ? true : false;
        let tPromise = await this.mMatManager.createResourceTexture(pId + "_roughness", ttmpLine[3] + "." + ttmpLine[2], talpha, pZIP).then((pTexture) => {
            if (pTexture != null) {
                pMaterial.microSurfaceTexture = pTexture;
                pMaterial.roughness = 1;
                pMaterial.metallic = 1;
                if (pMaterial.microSurfaceTexture !== null) {
                    pMaterial.microSurfaceTexture.uScale = this.mScaleU;
                    pMaterial.microSurfaceTexture.vScale = this.mScaleU;
                }
            }
        });
        return (pMaterial);
    }
    static createInitialMaterial(pId) {
        let tRes = new PbrMaterial(pId, this.mMatManager);
        tRes.name = pId;
        tRes.albedoColor = Color3.FromHexString("#aaaaaa");
        return (tRes);
    }
    static async downloadMATZ(url) {
        return downloadContent(url);
    }
    static async getMaterialDefinition(pMATZUrl, pId, pEntry) {
        this.mScaleU = 1;
        this.mScaleV = 1;
        let tFile = await this.downloadMATZ(pMATZUrl);
        if (tFile == null)
            return (0);
        let tMATZ = await ZipDocumentContainer.LoadContainer(tFile);
        if (tMATZ == null)
            return (0);
        let tFileList = await tMATZ.listFiles();
        let tmatFile = "";
        for (let tfile of tFileList) {
            if (tfile.toLocaleLowerCase().indexOf(".mat") != -1) {
                tmatFile = tfile;
                break;
            }
        }
        if (tmatFile == "")
            return (0);
        let tMATcontent = await tMATZ.getFile(tmatFile, false);
        if (tMATcontent.trim() == "")
            return (0);
        await this.collectMATParams(tMATcontent, tMATZ, pId, pEntry);
        return (Promise.resolve(1));
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static async collectMATParams(pMAT, pContainer, pId, pEntry) {
        let tMATparam = {};
        tMATparam.checksum = pId;
        let ttmp = pMAT.split("\n");
        for (let i = 0; i < ttmp.length; i++)
            ttmp[i] = ttmp[i].trim();
        for (let tStr of ttmp) {
            if (tStr.startsWith("type")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 2 && t_tmp[1].trim() != "") {
                    switch ((t_tmp[1].trim()).toLocaleLowerCase()) {
                        case "common":
                            tMATparam.type = "common";
                            break;
                        case "glass":
                            tMATparam.type = "glass";
                            break;
                        case "glass_translucent":
                            tMATparam.type = "glass_translucent";
                            break;
                        case "metal":
                            tMATparam.type = "metal";
                            break;
                        case "metal_polished":
                            tMATparam.type = "metal_polished";
                            break;
                        case "illuminant":
                            tMATparam.type = "illuminant";
                            break;
                        default:
                            break;
                    }
                }
            }
            if (tStr.startsWith("dif")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.dif = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                    tMATparam.baseColor = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("spe")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.spe = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("emission")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.emission = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("shi")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 2) {
                    tMATparam.shi = parseFloat(t_tmp[1]);
                }
            }
            if (tStr.startsWith("tra")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 2) {
                    tMATparam.tra = parseFloat(t_tmp[1]);
                }
            }
            if (tStr.startsWith("reflection")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 2) {
                    tMATparam.reflection = parseFloat(t_tmp[1]);
                }
            }
            if (tStr.startsWith("tex")) {
                let t_tmp = tStr.split(" ");
                if ((t_tmp.length == 4) && (t_tmp[1] == "image")) {
                    if (t_tmp[2].toLocaleLowerCase() == "png")
                        tMATparam.texTransparent = true;
                    else
                        tMATparam.texTransparent = false;
                    tMATparam.tex = t_tmp[3] + "." + t_tmp[2];
                    tMATparam.texChecksum = pId + "_tex";
                }
            }
            if (tStr.startsWith("offset")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.offset = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                    tMATparam.noffset = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("rotate")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.rotate = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                    tMATparam.nrotate = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("scale")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.scale = Util.StrToGfjVector2(t_tmp[1] + " " + t_tmp[2]);
                    tMATparam.nscale = Util.StrToGfjVector2(t_tmp[1] + " " + t_tmp[2]);
                }
            }
            if (tStr.startsWith("bumps")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 3) {
                    tMATparam.bumps = t_tmp[2] + "." + t_tmp[1];
                    tMATparam.bumpsChecksum = pId + "_bumps";
                }
            }
            if (tStr.startsWith("noffset")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.noffset = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("nrotate")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.nrotate = Util.StrToGfjVector3(t_tmp[1] + " " + t_tmp[2] + " " + t_tmp[3]);
                }
            }
            if (tStr.startsWith("nscale")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 4) {
                    tMATparam.nscale = Util.StrToGfjVector2(t_tmp[1] + " " + t_tmp[2]);
                }
            }
            if (tStr.startsWith("roughness")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 2) {
                    tMATparam.roughness = parseFloat(t_tmp[1]);
                }
                if ((t_tmp.length == 4) && (t_tmp[1] == "image")) {
                    tMATparam.roughnessTex = t_tmp[3] + "." + t_tmp[2];
                    tMATparam.roughnessChecksum = pId + "_roughness";
                }
            }
            if (tStr.startsWith("metallic")) {
                let t_tmp = tStr.split(" ");
                if (t_tmp.length == 2) {
                    tMATparam.metallic = parseFloat(t_tmp[1]);
                }
                if ((t_tmp.length == 4) && (t_tmp[1] == "image")) {
                    tMATparam.metallicTex = t_tmp[3] + "." + t_tmp[2];
                    tMATparam.metallicChecksum = pId + "_metallic";
                }
            }
        }
        let tmatLOAD = new GfjLoader(this.mRoomManager.app.model);
        if (!tmatLOAD.isPbrMaterial(tMATparam)) {
            await tmatLOAD.loadLegacyMaterialAsPbr(pId, pId, pEntry, tMATparam, pContainer);
        }
        else {
            await tmatLOAD.loadPbrMaterial(pEntry.materialValue, pEntry.materialValue, pEntry, tMATparam, pContainer);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
MATZLoader.mAngle = 0;
MATZLoader.mScaleU = 1;
MATZLoader.mScaleV = 1;
